import React, { useState, useEffect } from "react";
import { Card, Space, Typography, Image, List, Button, message, Col, Pagination } from "antd";
import { LocationIcon } from "../../../../atoms/Icons";
import { useNavigate } from "react-router-dom";

import * as status_types from "../../../../atoms/PropertyCard/constants";

import Logo from "../../../../../assets/img/BUILDING_placeholder.svg";
import { useDispatch, useSelector } from "react-redux";
import { getPropertyUnits } from "../ducks/actions";
import LoaderTsx from "../../../Loader.tsx";

const { Text } = Typography;

const getUnitCoverImageUrl = (galleryImages?: { position?: string | number; documentUrl?: string }[]) =>
  galleryImages?.find((img) => String(img.position) === "1" && img.documentUrl)?.documentUrl || Logo;

export default ({ propertyDetails, propertyId, updated }) => {
  const { buildingName, address } = propertyDetails;

  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const unitsApi = useSelector((state: any) => state.propertyDetails?.unitsList);
 
  const [isLoading, unitLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);

  const Statuses = (stat) => {
    // console.log(stat)
    switch (stat) {
      case status_types.PROPERTY_ENABLED:
        return "Active";
      case status_types.PROPERTY_DISABLED:
        return "Disabled";
      case status_types.PROPERTY_DRAFT:
        return "Vacant";
      case status_types.PROPERTY_RENTED:
        return "Occupied";
      case status_types.PROPERTY_PUBLISHED:
        return "Vacant";
      case status_types.PROPERTY_RESERVED:
        return "Reserved";
      case status_types.PROPERTY_BLOCKED:
        return "Blocked";
    }
  };



 

  useEffect(() => {
    dispatch(getPropertyUnits(propertyDetails?.propertyId, null, null, unitLoading, currentPage, limit, true));
  }, [currentPage]);

  return (
    <Card bordered={false} bodyStyle={{ padding: "32px 24px", width: "100%" }}>
      <>
        <Col span={24} style={{ marginBottom: "10px" }}>
          <Pagination
            className="ag-property-text-pagination"
            total={unitsApi?.totalCount || 0}
            showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} Units`}
            showSizeChanger={false}
            defaultPageSize={limit}
            defaultCurrent={1}
            current={currentPage}
            onChange={(e) => setCurrentPage(e)}
          />
        </Col>
        {isLoading ? (
          <LoaderTsx />
        ) : (
          <div
            id="scrollableDiv"
            style={{
              height: 500,
              overflow: "auto",
              padding: "0 16px",
            }}
          >
            <List
              bordered={false}
              className="unit_list"
              itemLayout="horizontal"
              dataSource={unitsApi?.data || []}
              renderItem={(item: any) => (
                <List.Item
                  className="no-border"
                  actions={[
                    <Space direction="vertical" size={4} className="text-right">
                      <Button
                        className="property_card_btn"
                        type="primary"
                        onClick={() =>
                          navigate(`/property-detail/${propertyId}/unit/${item._id}`, {
                            state: { parentname: buildingName, usageType: item?.unit?.usagesType },
                          })
                        }
                      >
                        View Unit
                      </Button>
                    </Space>,
                  ]}
                >
                  <List.Item.Meta
                    style={{ alignItems: "center" }}
                    avatar={
                      <Space style={{ position: "relative" }}>
                        <Image
                          src={getUnitCoverImageUrl(item.galleryImages)}
                          placeholder={true}
                          preview={false}
                          width={164}
                          height={115}
                          fallback={Logo}
                        />
                        <Text
                          className={`statusUnit ${item?.unitStatus === "disabled" ? "inactive" : ""} ${
                            item?.unitStatus === "occupied" ? "inactive" : ""
                          } ${item?.unitStatus === "reserved" ? "inactive" : ""} ${
                            item?.blockData?.block ? "inactive-block" : ""
                          }`} //vacant, occupied, reserved
                        >
                          {Statuses(item?.blockData?.block ? "blocked" : item?.unitStatus)}
                        </Text>
                      </Space>
                    }
                    description={
                      <Space size={0} direction="vertical">
                        <Text className="ag-primary fontWeight700">
                          {buildingName} {item.unit ? item.unit?.unitCode : ""}
                        </Text>
                        <Text className="smallFont12">
                          {buildingName} {item.unit?.usageType ? "- " + item.unit?.usageType : ""}
                        </Text>
                        <Space size={4}>
                          <LocationIcon className="ag-default" />
                          <Text className="smallFont12 ag-primary">
                            {address ? (address?.addressLine2 ?? address?.addressLine1) + " " + address?.emirates : ""}
                          </Text>
                        </Space>
                        <Text className="smallFont12">
                          {item.unit
                            ? item.unit?.unitSubType +
                              " - " +
                              item.unit?.unitType +
                              " - " +
                              item.unit?.areaSqft +
                              " sq.ft."
                            : ""}
                        </Text>
                      </Space>
                    }
                  />
                </List.Item>
              )}
            />
          </div>
        )}
      </>
    </Card>
  );
};
